/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      service — app-level override point for beebee-base's intl
 *              service; currently adds no behavior of its own
 *   extends:   IntlService (beebee-base/services/intl)
 *   template:  none
 *   key:       - (empty subclass; all behavior inherited)
 *   uses:      beebee-base/services/intl
 *   siblings:  -
 *   tests:     none (only reached incidentally via `@service intl`
 *              injections across the app's own tests; no dedicated
 *              test file exercises this override)
 *
 * Re-registers beebee-base's IntlService under this app so it can be
 * overridden locally later; today it is a pure pass-through.
 */
import IntlService from 'beebee-base/services/intl';

export default class Intl extends IntlService {}
